<script lang="ts">
  import { venuePanelState, type VenueStateLike } from "./session";

  let { venueState }: { venueState: VenueStateLike } = $props();
  let decision = $derived(venuePanelState(venueState));
</script>

{#if decision.closed}
  <div class="venue-closed" role="status" aria-live="polite">{decision.pill}</div>
{/if}

<style>
  /* Tokens only — both themes come from the same variables the chip uses, so this element
     cannot drift from the palette that was measured for contrast. No literal colours. */
  .venue-closed {
    display: inline-flex;
    align-items: center;
    padding: 2px 7px;
    font-size: 10px;
    letter-spacing: 0.04em;
    color: var(--ink);
    background: var(--surface-2);
    border: 1px solid var(--line);
    border-radius: 5px;
    font-weight: 700;
    /* R4 (ORDER_HUD_CALIBRATION_1): THE CHIP TEXT WRAPS. `nowrap` gave this banner an
       unshrinkable intrinsic width - measured 235 px - and in a wrapped `.panel-pills` row it
       lands at x=203, so at a 390 viewport the DOCUMENT scrollWidth read 438. `normal` wraps
       only when the text cannot fit, so desktop widths are unchanged; `overflow-wrap: anywhere`
       is the same treatment `.age` already carries in ExpiryTidePanel. */
    white-space: normal;
    overflow-wrap: anywhere;
    max-width: 100%;
  }
</style>
